var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dl',{staticClass:"grid gap-x-4 gap-y-8 grid-cols-1 lg:grid-cols-2"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }